import * as Yup from 'yup';

export type Configuration = string | null;

export const configurationPresent = (configuration: Configuration) => !(configuration === '{}' || !configuration);

export const defaultConfiguration: Configuration = '{}';

export const ConfigurationSchema = (fieldName: string) => Yup.string().test(fieldName, 'Invalid configuration', (value: any) => {
    try {
        const object = JSON.parse(value);
        if (!Array.isArray(object)) {
            for (const key in object) {
                if (typeof object[key] !== 'string') {
                    return false;
                }
            }
        } else {
            return false;
        }
    } catch (e) {
        return false;
    }
    return true;
});
